import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Route, Redirect, Switch, withRouter,
} from 'react-router-dom';

import { ContainerWithLogo } from '@app/components';
import RouterConstants from '@app/constants/router';
import WizardHeader from './components/WizardHeader';
import {
  SelectOption,
  Promotion,
  SignUp,
  SuccessfulSignUp,
  SignUpConfirm,
  PaymentResults,
} from './steps';

const subscribeSteps = [
  {
    labelId: 'subscribe.step1',
    routes: [
      RouterConstants.SUBSCRIBE,
      RouterConstants.SUBSCRIBE_PROMOTION,
    ],
  },
  {
    labelId: 'subscribe.step2',
    routes: [
      RouterConstants.SIGN_UP,
      RouterConstants.SIGN_UP_SUCCESS,
      RouterConstants.SIGN_UP_CONFIRM,
    ],
  },
  {
    labelId: 'subscribe.step3',
    routes: [
      RouterConstants.PAYMENT_RESULT,
    ],
  },
];

const Subscribe = ({
  pathname, isOptionSelected, isLoggedIn, isPaymentSuccess, promoCode,
}) => {
  const activeStepIndex = subscribeSteps.findIndex(({ routes }) => routes.includes(pathname));
  const completedSteps = [];

  if (isOptionSelected && activeStepIndex !== 0) completedSteps.push(0);
  if (isLoggedIn) completedSteps.push(1);
  if (pathname === RouterConstants.PAYMENT_RESULT && isPaymentSuccess) completedSteps.push(2);

  return (
    <ContainerWithLogo titleLabel="subscribe.header">
      <WizardHeader
        steps={subscribeSteps}
        activeStepIndex={activeStepIndex}
        completedSteps={completedSteps}
      />
      <Switch>
        <Route exact path={RouterConstants.SUBSCRIBE} component={SelectOption} />
        <Route
          exact
          path={RouterConstants.SUBSCRIBE_PROMOTION}
          render={() => (isOptionSelected && promoCode
            ? <Promotion />
            : <Redirect to={{ pathname: RouterConstants.SUBSCRIBE }} />
          )}
        />
        <Route
          exact
          path={RouterConstants.SIGN_UP}
          render={() => {
            if (isLoggedIn) return <Redirect to={{ pathname: RouterConstants.HOME }} />;
            if (isOptionSelected) return <SignUp />;
            return <Redirect to={{ pathname: RouterConstants.SUBSCRIBE }} />;
          }}
        />
        <Route
          path={RouterConstants.SIGN_UP_SUCCESS}
          render={() => (
            isOptionSelected ? <SuccessfulSignUp /> : <Redirect to={{ pathname: RouterConstants.HOME }} />
          )}
        />
        <Route
          path={RouterConstants.SIGN_UP_CONFIRM}
          component={SignUpConfirm}
        />
        <Route
          exact
          path={RouterConstants.PAYMENT_RESULT}
          render={() => (isLoggedIn ? <PaymentResults /> : <Redirect to={{ pathname: RouterConstants.SIGN_IN }} />)}
        />
        <Route render={() => (<Redirect to={RouterConstants.HOME} />)} />
      </Switch>
    </ContainerWithLogo>
  );
};

Subscribe.propTypes = {
  pathname: PropTypes.string.isRequired,
  isOptionSelected: PropTypes.bool,
  promoCode: PropTypes.string,
  isLoggedIn: PropTypes.bool.isRequired,
  isPaymentSuccess: PropTypes.bool.isRequired,
};

Subscribe.defaultProps = {
  isOptionSelected: false,
  promoCode: '',
};

const mapStateToProps = ({
  router: { location: { pathname } },
  subscribe: { selectedOptionId, promoCode },
  payment: { error },
  user: { isLoggedIn },
}) => ({
  isOptionSelected: selectedOptionId !== null,
  isPaymentSuccess: !error,
  isLoggedIn,
  promoCode,
  pathname,
});

export default withRouter(connect(mapStateToProps)(Subscribe));
